module.exports = __webpack_public_path__ + "img/foreign.9453089.png";